// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  // 加載列表
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Module/Load',
      params,
    });
  },
  // 抓取單筆
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Module/Get',
      params,
    });
  },
  // 新增
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Module/Add',
      data,
    });
  },
  // 更新
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Module/Update',
      data,
    });
  },
  // 刪除
  Delete(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Module/Delete',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
  // 綁定權限
  RoleBind(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Module/RoleBind',
      data,
    });
  },
  // 取得綁定資料
  GetRoleBind(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Module/GetRoleBind',
      params,
    });
  },
};
